import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { ITA_AIRWAYS } from '../data/airlinesData';

export default function ItaAirwaysPage() {
  return <AirlineDetailPage airline={ITA_AIRWAYS} />;
}
